import './index.less';
import _videojs from 'video.js';
import player from './Player.vue';

const videojs = window.videojs || _videojs;
const install = function(Vue, config) {
  if (config) {
    if (config.options) {
      player.props.globalOptions.default = () => config.options;
    }
    if (config.events) {
      player.props.globalEvents.default = () => config.events;
    }
  }
  Vue.component(player.name, player);
};

export default { videojs, player, install };
export { player, videojs, install };
